import React from "react";
import UserNavbar from "../../components/user/UserNavbar";

const OrganizationBase = ({ children }) => {
  return (
    <div className="container-fluid p-0 m-0">
      {/* Hide Trusts, Beneficiaries, Attorneys/Agents for org dashboard */}
      <UserNavbar hiddenLinks={["trusts", "beneficiaries", "attorneys"]} />
      {children}
    </div>
  );
};

export default OrganizationBase;
